import AuthService from '../../shared/services/AuthService';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Unstable_Grid2';
import MessageBox from './MessageBox';
import React from 'react';
import Typography from '@mui/material/Typography';

interface VerifyEmailCodeExpiredProps {
  email: string;
  username: string;
}

const VerifyEmailCodeExpired = (props: VerifyEmailCodeExpiredProps) => {
  const tenant = AuthService.Tenant;
  return (
    <>
      <MessageBox
        header="Whoops!"
        message="Your email verification link has expired."
        secondaryMessage="Check that you are clicking the most recent verification link."
      />
      <Box m={1}>
        <Divider />
      </Box>
      <Grid
        container
        direction="column"
        alignItems="center"
        justifyContent="center"
      >
        <Grid>
          <Typography variant="body1">Need a new link?</Typography>
        </Grid>
        <Grid>
          <Button
            color="primary"
            onClick={(e) => {
              e.preventDefault();
              window.location.href = `${window.location.origin}/request-verification-email?tenant=${tenant}&username=${props.username}&request-only=true`;
            }}
          >
            Request a new link
          </Button>
        </Grid>
      </Grid>
    </>
  );
};

export default VerifyEmailCodeExpired;
